import http from "@/http.ts";

export class User {
    id: number | null = null;
    roles: { [key: string]: string[]} = {};
    emgyneCity: string = '';
    emmaCity: string = '';
    name: string | null = null;
    full_name: string | null = null;
    access_token: string | null = null;
    refresh_token: string | null = null;

    isAuthenticated(): boolean {
        if (this.id === null) {
            const serializedUser = window.localStorage.getItem("user");
            if (serializedUser) {
                const user = JSON.parse(serializedUser);
                this.id = user.id;
                this.access_token = user.access_token;
                this.refresh_token = user.refresh_token;
                this.roles = user.roles;
                if (typeof this.roles === 'string')
                    this.roles = JSON.parse(this.roles);
                this.emgyneCity = user.emgyneCity;
                this.emmaCity = user.emmaCity;
                this.name = user.name;
                this.full_name = user.full_name;
            }
        }
        return this.id !== null;
    }

    async login(email: string, password: string) {
        window.localStorage.removeItem("user");
        this.id = null;
        let response = await http.post("/auth/login", {
            email: email,
            password: password
        });
        this.access_token = response.data.access_token;
        this.refresh_token = response.data.refresh_token;
        response = await http.get("/auth/user", {
            headers: {
                Authorization: "Bearer " + this.access_token
            }
        });
        this.roles = response.data.me.roles;
        if( typeof this.roles === 'string' )
            this.roles = JSON.parse( this.roles );
        this.name = response.data.me.name;
        this.full_name = response.data.me.full_name;
        this.id = response.data.me.user_id;
        window.localStorage.setItem("user", JSON.stringify(this));
    }

    async refresh() {
        const response = await http.post(
            "/auth/refresh",
            { refresh_token: this.refresh_token },
            {
                headers: {
                    Authorization: "Bearer " + this.access_token
                }
            }
        );
        this.access_token = response.data.access_token;
        this.isAuthenticated();
        window.localStorage.setItem("user", JSON.stringify(this));
    }

    logout() {
        window.localStorage.removeItem("user");
        const access_token = this.access_token;
        this.id = null;
        this.name = null;
        this.roles = {};
        this.access_token = null;
        this.refresh_token = null;
        http.post("/auth/logout", undefined,
        {
            headers: {
                Authorization: "Bearer " + access_token
            }
        } );
    }
}

export let authUser: User = new User();
